module.exports = __webpack_public_path__ + "igPopoverArrows.3a139d6db391c8ecda65.png";


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/assets/img/igPopoverArrows.png
// module id = ../../../../../client/assets/img/igPopoverArrows.png
// module chunks = styles